module.exports = __webpack_public_path__ + "static/media/genuine-background-TH.ee2f9b64.png";